import { render, staticRenderFns } from "./sendMessageDetailContent.vue?vue&type=template&id=3732fd49"
import script from "./sendMessageDetailContent.vue?vue&type=script&lang=js"
export * from "./sendMessageDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports